
const SolutionsHero = () => {
  return (
    <section 
      className="relative py-20 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/b0bb1ebce4d4a3fb107f8554e8886fd2.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Chemical Solutions for <span className="text-teal-400">Oilfield Operations</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-gray-200">
          Comprehensive range of specialized chemicals designed for upstream, midstream, and downstream oil & gas operations
        </p>
      </div>
    </section>
  );
};

export default SolutionsHero;
